import LogoGraySpinner from './LogoGraySpinner';

const FullpageAnimatedLogo = () => {
  return (
    <>
      <style>{'body{overflow:hidden}'}</style>
      <div className='bg-body-light fixed z-50 flex h-[calc(100svh-80px)] w-full items-center justify-center overflow-hidden rounded-md'>
        <LogoGraySpinner className='text-primary h-32 w-32' />
      </div>
    </>
  );
};

export default FullpageAnimatedLogo;
